function FormWrapper({ title, subtitle, children, footer, className = "" }) {
  return (
    <div className={`w-full overflow-visible bg-transparent ${className}`.trim()}>
      {(title || subtitle) && (
        <div className="px-4 py-3 text-center">
          {title && (
            <h2 className="text-xl font-black tracking-tight text-[#111c33] dark:text-[#f3f4f6]">
              {title}
            </h2>
          )}
          {subtitle && (
            <p className="mt-1 text-xs leading-relaxed text-[#4a5568] dark:text-[#b6bfd1]">
              {subtitle}
            </p>
          )}
        </div>
      )}

      <div className="px-4 pb-4">{children}</div>

      {footer && (
        <div className="border-t border-[#d7d1c4] px-4 py-3 dark:border-[#1a2743]">
          <div className="flex items-center justify-center">{footer}</div>
        </div>
      )}
    </div>
  );
}

export default FormWrapper;
